import { render, staticRenderFns } from "./RegTips.vue?vue&type=template&id=39968309&scoped=true&"
import script from "./RegTips.vue?vue&type=script&lang=js&"
export * from "./RegTips.vue?vue&type=script&lang=js&"
import style0 from "./RegTips.vue?vue&type=style&index=0&id=39968309&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39968309",
  null
  
)

export default component.exports